/** Location email identity GraphQL operations (TRK-6050). Result types are inferred from selection sets. */

import { graphql } from 'app/generated/gql'

// Verified sending domains for the workspace — the pool the location's From
// address picks from.
export const SENDING_DOMAINS_FOR_IDENTITY_QUERY = graphql(`
  query SendingDomainsForIdentity($search: String) {
    sendingDomains(search: $search) {
      hits {
        id
        domain
        type
        status
      }
      total
    }
  }
`)

// The shared global Trackable domain — always an option, no SendingDomain row.
export const TRACKABLE_SENDING_DOMAIN_QUERY = graphql(`
  query TrackableSendingDomain {
    trackableSendingDomain
  }
`)

// Live global availability check for a From address. Save is blocked until true.
export const CHECK_SENDING_EMAIL_AVAILABLE_QUERY = graphql(`
  query CheckSendingEmailAvailable($localPart: String!, $domain: String!, $locationId: ID) {
    checkSendingEmailAvailable(localPart: $localPart, domain: $domain, locationId: $locationId)
  }
`)

export const LOCATION_EMAIL_IDENTITIES_QUERY = graphql(`
  query LocationEmailIdentities($search: String) {
    locationEmailIdentities(search: $search) {
      hits {
        id
        locationId
        sendingDomainId
        domain
        localPart
        address
        fromName
        replyTo
      }
      total
    }
  }
`)

export const SET_LOCATION_EMAIL_IDENTITY_MUTATION = graphql(`
  mutation SetLocationEmailIdentity($input: SetLocationEmailIdentityInput!) {
    setLocationEmailIdentity(input: $input) {
      id
      locationId
      sendingDomainId
      domain
      localPart
      address
      fromName
      replyTo
    }
  }
`)

export const DELETE_LOCATION_EMAIL_IDENTITY_MUTATION = graphql(`
  mutation DeleteLocationEmailIdentity($id: ID!) {
    deleteLocationEmailIdentity(id: $id)
  }
`)
